import { useCallback, useState } from "react";

// Force-rerender a component
export const useForceUpdate = () => {
  const [, dispatch] = useState();
  return useCallback(() => {
    dispatch(Object.create(null));
  }, [dispatch]);
};
